import React, { useEffect } from 'react';
import { Analytics } from '@vercel/analytics/react';
import { BrowserRouter as Router, Navigate, Route, Routes, useLocation } from 'react-router-dom';
// Shared tokens and layout first, so component styles can override them.
import './variables.css';
import './App.css';
import Navbar from './components/navbar/navbar';
import About from './components/about/about';
import Projects from './components/projects/projects';
import Experience from './components/experience/experience';
import { RESUME_URL } from './data/links';

const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

// /resume used to be a page; send old links straight to the PDF.
const ResumeRedirect: React.FC = () => {
  useEffect(() => {
    window.location.replace(RESUME_URL);
  }, []);
  return null;
};

const App: React.FC = () => {
  return (
    <Router>
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<About />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/experience" element={<Experience />} />
        <Route path="/resume" element={<ResumeRedirect />} />
        {/* Old page URLs */}
        <Route path="/software" element={<Navigate to="/projects" replace />} />
        <Route path="/hardware" element={<Navigate to="/projects" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Analytics />
    </Router>
  );
};

export default App;
